export const imports = {
  'docs/src/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-src-index" */ 'docs/src/index.mdx'
    ),
  'docs/src/PinningSections/StickyPlot.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-src-pinning-sections-sticky-plot" */ 'docs/src/PinningSections/StickyPlot.mdx'
    ),
  'docs/src/PinningSections/StickyScene.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-src-pinning-sections-sticky-scene" */ 'docs/src/PinningSections/StickyScene.mdx'
    ),
  'docs/src/ScrollTracking/Plot.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-src-scroll-tracking-plot" */ 'docs/src/ScrollTracking/Plot.mdx'
    ),
  'docs/src/ScrollTracking/Section.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-src-scroll-tracking-section" */ 'docs/src/ScrollTracking/Section.mdx'
    ),
  'docs/src/RevealingAnimations/Trigger.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-src-revealing-animations-trigger" */ 'docs/src/RevealingAnimations/Trigger.mdx'
    ),
}
